import { useState, useRef } from '@wordpress/element';
import { 
    BaseControl,
    Button,
    Dropdown,
    MenuGroup,
    MenuItem,
    RangeControl
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import './style.scss';
import { Icons } from '../../utils/icons';

const DeviceIcon = ({ type }) => {
    switch (type) {
        case 'desktop':
            return (
                Icons.desktop
            );
        case 'tablet':
            return (
                Icons.tablet
            );
        case 'mobile':
            return (
                Icons.mobile
            );
        default:
            return null;
    }
};

const ResponsiveNumber = ({ 
    value = {}, 
    onChange, 
    label = __('Sütun Sayısı', 'kan'),
    min = 1,
    max = 6,
    defaultValues = { desktop: 3, tablet: 2, mobile: 1 }
}) => {
    const [activeDevice, setActiveDevice] = useState('desktop');
    const dropdownRef = useRef();

    const devices = [
        { name: 'desktop', label: __('Masaüstü', 'kan') },
        { name: 'tablet', label: __('Tablet', 'kan') },
        { name: 'mobile', label: __('Mobil', 'kan') }
    ];

    const updateValue = (newValue) => {
        onChange({
            ...value,
            [activeDevice]: newValue
        });
    };

    const getCurrentValue = () => {
        if (!value[activeDevice]) return defaultValues[activeDevice];
        return value[activeDevice];
    };

    const resetValue = () => {
        onChange(defaultValues);
    };

    const handleDeviceChange = (device) => {
        setActiveDevice(device);
        if (dropdownRef.current) {
            dropdownRef.current.toggle();
        }
    };

    return (
        <BaseControl className="kan-control-item kan-responsive-number">
            <div className="kan-control-header">
                <span className="kan-control-label">{label}</span>
                <div className="kan-control-actions">
                    <Dropdown
                        ref={dropdownRef}
                        className="kan-device-dropdown"
                        contentClassName="kan-device-dropdown-content"
                        position="bottom right"
                        renderToggle={({ isOpen, onToggle }) => (
                            <Button
                                onClick={onToggle}
                                aria-expanded={isOpen}
                                className="kan-device-button"
                            >
                                <DeviceIcon type={activeDevice} />
                            </Button>
                        )}
                        renderContent={() => (
                            <MenuGroup>
                                {devices.map(device => (
                                    <MenuItem
                                        key={device.name}
                                        onClick={() => handleDeviceChange(device.name)}
                                        isSelected={activeDevice === device.name}
                                    >
                                        <DeviceIcon type={device.name} />
                                        <span>{device.label}</span>
                                    </MenuItem>
                                ))}
                            </MenuGroup>
                        )}
                    />
                    <Button
                        isSmall
                        isSecondary
                        onClick={resetValue}
                        className="kan-reset-button"
                        icon="image-rotate"
                    />
                </div>
            </div>

            <div className="kan-control-inputs">
                <div className="kan-control-box">
                    <RangeControl
                        value={getCurrentValue()}
                        onChange={updateValue}
                        min={min}
                        max={max}
                        allowReset
                        resetFallbackValue={defaultValues[activeDevice]}
                    />
                </div>
            </div>
        </BaseControl>
    );
};

export default ResponsiveNumber; 